import stringHelpers from "../../utilities/stringHelpers";
export const TimeRangeDragHandle = ({ isDragging, handleMouseDown, timeValue, backgroundColourUtility, plusOneUnit, minusOneUnit }) => {
    return (
        <div
            className="position-absolute translate-middle bg-white border border-4 border-secondary rounded time-range-drag-handle"
            style={ {                
                left: `${ (timeValue / 1440) * 100 }%`,
                cursor: isDragging === 'start' ? 'grabbing' : 'grab',
                zIndex: isDragging === 'start' ? 10 : 5
            } }
            onMouseDown={ handleMouseDown('start') }
            onClick={ (e) => {
                if (!isDragging) {
                    e.stopPropagation();
                }
            } }
        >
            <i className='fas fa-grip-lines fs--1 ml-1'></i>
            <div className={`position-absolute bg-${backgroundColourUtility} text-white small py-1 px-2 rounded time-range-drag-handle-display-box`} >
                <button onClick={() => minusOneUnit()} className="position-absolute btn p-0" style={{left: "-10px", top: "6px"}} ><i className="fas fa-chevron-left text-dark fs--1"></i></button>
                { stringHelpers.formatMinutesToTwentyFourHourClock(timeValue) }
                <button onClick={() => plusOneUnit()} className="position-absolute btn p-0" style={{right: "-10px", top: "6px"}} ><i className="fas fa-chevron-right text-dark fs--1 ml-1"></i></button>
            </div>
        </div>
    )
}